(function() { window.GUID_f2553321_6c97_4278_816f_6c920257a81b = { getGuid: function() { return "f2553321-6c97-4278-816f-6c920257a81b"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-matches-v2",
                        callback: (accordion, e) => {
                            let refreshingContent = false;
                            accordion.$Content.offon("click.pinResults", "#button-pin-results", (e) => {
                                const $btn = $(e.currentTarget);
                                const { pinUrl, successmsg } = $btn.data("html");
                                if (pinUrl != null) {
                                    accordion.pinSection(pinUrl, accordion, () => {
                                        if (!CS.Helper.isNullOrWhiteSpace(successmsg)) {
                                            CS.Controls.Snackbar.Show({
                                                Id: "pin-toggle-success",
                                                Alignment: CS.Enumeration.SnackbarAlignment.BottomCenter,
                                                Animation: CS.Enumeration.SnackbarAnimation.Slide,
                                                Type: CS.Enumeration.SnackbarType.Success,
                                                Message: successmsg,
                                                AutoHideDuration: 3000,
                                            });
                                        }
                                    });
                                }
                            });
                            if (!WallSections.MatchesSection.isWallLayout) {
                                WallSections.MatchesSection.removeLazyloadingTrigger(accordion);
                                return;
                            }
                            let filtersUIFreezed = false;
                            //const { instance } = MatchesSection;
                            CS.Controls.FiltersBar.Events.ChipClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-matches-${accordion.ContentId}-bar`,
                                callback: (filtersBar, e) => {
                                    CS.Helper.log("AccordionMatchesV2", "ChipClicked", e);
                                    if (filtersBar.uiFreezed)
                                        return;
                                    filtersUIFreezed = true;
                                    const url = WallSections.MatchesSection.formatSectionUrl(e.data.toggleUrl, accordion);
                                    refreshingContent = true;
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        filtersBar.uiFreezed = false;
                                        filtersUIFreezed = false;
                                        WallSections.MatchesSection.updateUI(accordion);
                                        yield filtersBar.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                    }), url);
                                },
                            });
                            CS.Controls.FiltersBar.Events.SortItemClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-matches-${accordion.ContentId}-bar`,
                                callback: (filtersBar, e) => {
                                    CS.Helper.log("AccordionMatchesV2", "SortItemClicked", e.data);
                                    const url = WallSections.MatchesSection.formatSectionUrl(e.data.url, accordion);
                                    refreshingContent = true;
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        filtersUIFreezed = false;
                                        WallSections.MatchesSection.updateUI(accordion);
                                        yield filtersBar.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                    }), url);
                                },
                            });
                            //=================================================================================//
                            //============================// Filters V2
                            // Controls.Filters.Events.SortItemClicked({
                            //     selector: DOM.$body,
                            //     childSelector: `#filters-drawer-matches-${accordion.ContentId}-bar`,
                            //     callback: (filters, e) => {
                            //         Helper.log("AccordionMatchesV2", "SortItemClicked", e.data);
                            //         const url = MatchesSection.formatSectionUrl(e.data.url, accordion);
                            //         refreshingContent = true;
                            //         accordion.RefreshContent(() => {
                            //             filtersUIFreezed = false;
                            //             MatchesSection.updateUI(accordion);
                            //             await filters.UpdateFiltersStateInBrowserUrl(
                            //                 e.data.filtersStateSerialized
                            //             );
                            //         }, url);
                            //         const $parentPopup = $(
                            //             `#popup-filters-drawer-filters-matches-${accordion.ContentId}-bar`
                            //         );
                            //         const parentPopup = Controls.GetInstance(
                            //             Controls.Popup,
                            //             $parentPopup,
                            //             true
                            //         );
                            //         if (parentPopup != null) parentPopup.Close();
                            //     },
                            // });
                            CS.Controls.Filters.Events.SortItemClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-drawer-matches-${accordion.ContentId}-bar`,
                                callback: (filters, e) => {
                                    CS.Helper.log("AccordionMatchesV2", "SortItemClicked", e.data);
                                    const url = WallSections.MatchesSection.formatSectionUrl(e.data.url, accordion);
                                    refreshingContent = true;
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        filtersUIFreezed = false;
                                        WallSections.MatchesSection.updateUI(accordion);
                                        yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                    }), url);
                                    const $parentPopup = $(`#popup-filters-drawer-filters-matches-${accordion.ContentId}-bar`);
                                    const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                    if (parentPopup != null)
                                        parentPopup.Close();
                                },
                            });
                            //Controls.Filters.Events.Disposed({
                            //  selector: DOM.$body,
                            //  childSelector: `#filters-drawer-matches-${accordion.ContentId}-bar`,
                            //  callback: (filters, e) => {
                            //    if (refreshingContent) return;
                            //    if (e.data.inDrawer) {
                            //      Helper.log("AccordionMatchesV2", "Filters were disposed in drawer");
                            //    }
                            //  },
                            //});
                            CS.Controls.Filters.Events.FiltersToggleClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-drawer-matches-${accordion.ContentId}-bar`,
                                callback: (filters, e) => __awaiter(this, void 0, void 0, function* () {
                                    CS.Helper.log("AccordionMatchesV2", "FiltersToggleClicked", e.data);
                                    if (e.data.filtersStateSerialized) {
                                        yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                        const $parentPopup = $(`#popup-filters-drawer-filters-matches-${accordion.ContentId}-bar`);
                                        const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                        if (parentPopup != null)
                                            parentPopup.Close();
                                    }
                                }),
                            });
                            CS.Controls.Filters.Events.ItemClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-drawer-matches-${accordion.ContentId}-bar`,
                                callback: (filters, e) => {
                                    CS.Helper.log("AccordionMatchesV2", "ItemClicked", e.data);
                                    const url = WallSections.MatchesSection.formatSectionUrl(e.data.url, accordion);
                                    refreshingContent = true;
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        filtersUIFreezed = false;
                                        WallSections.MatchesSection.updateUI(accordion);
                                        yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                    }), url);
                                    const $parentPopup = $(`#popup-filters-drawer-filters-matches-${accordion.ContentId}-bar`);
                                    const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                    if (parentPopup != null)
                                        parentPopup.Close();
                                },
                            });
                            CS.DivisionsPicker.OnItemClick(`filters-shortcut-divisions-${accordion.ContentId}`, (divisionId, customUrl, divisionPicker) => __awaiter(this, void 0, void 0, function* () {
                                try {
                                    const $picker = $(`#filters-shortcut-divisions-${accordion.ContentId}`);
                                    const $container = $picker.closest(".divisions-picker-container");
                                    const overridableUrl = $container.attr("data-overridable-url");
                                    const filterType = $container.attr("data-filter-type");
                                    const filtersUrl = yield CS.Controls.Filters.ReplaceValueInOverridableUrl(overridableUrl, divisionId, filterType);
                                    const url = WallSections.MatchesSection.formatSectionUrl(filtersUrl, accordion);
                                    refreshingContent = true;
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        filtersUIFreezed = false;
                                        WallSections.MatchesSection.updateUI(accordion);
                                        const filtersStateSerialized = yield CS.Controls.Filters.ExtractFiltersStateFromUrl(filtersUrl);
                                        yield CS.Controls.Filters.UpdateFiltersStateInBrowserUrlStatic(filtersStateSerialized);
                                    }), url);
                                }
                                catch (error) {
                                    console.error("Error while handling division picker item click", error);
                                }
                            }));
                            CS.Controls.Filters.Events.FilterToggleClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-drawer-matches-${accordion.ContentId}-bar`,
                                callback: (filters, e) => {
                                    CS.Helper.log("AccordionMatchesV2", "FilterToggleClicked", e.data);
                                    const url = WallSections.MatchesSection.formatSectionUrl(e.data.toggleUrl, accordion);
                                    refreshingContent = true;
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        filtersUIFreezed = false;
                                        WallSections.MatchesSection.updateUI(accordion);
                                        yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                    }), url);
                                    const $parentPopup = $(`#popup-filters-drawer-filters-matches-${accordion.ContentId}-bar`);
                                    const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                    if (parentPopup != null)
                                        parentPopup.Close();
                                },
                            });
                            CS.Controls.Filters.Events.TextChanged({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-drawer-matches-${accordion.ContentId}-bar`,
                                callback: (filters, e) => {
                                    const url = WallSections.MatchesSection.formatSectionUrl(e.data.url, accordion);
                                    refreshingContent = true;
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        console.log(url);
                                        filtersUIFreezed = false;
                                        WallSections.MatchesSection.updateUI(accordion);
                                        yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                    }), url);
                                    const $parentPopup = $(`#popup-filters-drawer-filters-matches-${accordion.ContentId}-bar`);
                                    const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                    if (parentPopup != null)
                                        parentPopup.Close();
                                },
                            });
                            //=================================================================================//
                            //============================// Show/Hide custom preset
                            //instance._filtersAreCollapsed = accordion.$Content
                            //    .find(".filters")
                            //    .hasClass("collapsed");
                            //MatchesSection.toggleCustomPresetVisibility(
                            //    MatchesSection.filtersAreCollapsed
                            //);
                            //=================================================================================//
                            //============================// Show filters event
                            const showFilters = () => window.scrollTo({ behavior: "smooth", top: 0, left: 0 });
                            CS.DOM.$body.offon("click.filtersShortcut", "#section-top .filters", (e) => showFilters());
                            //accordion.$Content.offon("click.filtersShortcut", ".chips .chip", (e) =>
                            //  showFilters()
                            //);
                            //=================================================================================//
                            //============================// Lazyloading setup
                            WallSections.MatchesSection.setLazyloadingUrl(accordion);
                            const $lazyloadingTrigger = $(".button-lazy-loader-trigger");
                            if ($lazyloadingTrigger.length)
                                CS.Lag(`${accordion.ControlId}-lazyload`, 500, () => $lazyloadingTrigger.trigger("click"));
                            //=================================================================================//
                            //============================// Formats
                            CS.DOM.$body.offon("click.dropdownMatchesV2Formats", ".dropdown-matches-format", (e) => {
                                if (!filtersUIFreezed) {
                                    const $dropdown = $(e.currentTarget);
                                    const $itemClicked = $(e.target).closest(".list-item");
                                    if ($itemClicked.length && $dropdown.find($itemClicked).length) {
                                        const { url, isCurrent, isDisabled } = WallSections.MatchesSection.extractData($itemClicked.data("extravalues"), accordion);
                                        if (!isCurrent) {
                                            let shouldRefreshContent = true;
                                            if (isDisabled == null) {
                                                shouldRefreshContent = true;
                                            }
                                            else if (isDisabled) {
                                                shouldRefreshContent = false;
                                            }
                                            if (shouldRefreshContent) {
                                                filtersUIFreezed = true;
                                                refreshingContent = true;
                                                accordion.RefreshContent(() => {
                                                    filtersUIFreezed = false;
                                                    WallSections.MatchesSection.updateUI(accordion);
                                                }, url);
                                            }
                                            else {
                                                if (WallSections.MatchesSection.filtersAreCollapsed)
                                                    accordion.$Content.find(".filters-toggle").trigger("click");
                                                else
                                                    showFilters();
                                                // TODO : Si on doit afficher une Snackbar, on le fait et on open les filtres
                                                const $divisionsFilter = $(".filters .filter.division");
                                                $divisionsFilter.addClass("highlighted-blink--slow");
                                                CS.Lag("fwadwawfaadaweaw", 2000, () => $divisionsFilter.removeClass("highlighted-blink--slow"));
                                            }
                                        }
                                    }
                                }
                            });
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=matches-section.ready.js.map
